// extracted by mini-css-extract-plugin
export default {"modal":"index_modal__QgsvO","img":"index_img__JY5ZT","body":"index_body__Sp7HG","closeBtn":"index_closeBtn__x6S-R"};